import React from 'react';
import { Shield, Handshake, Award, CheckCircle } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const icons = [Shield, Handshake, Award, CheckCircle];

const CoreValues = () => {
  const { t } = useLanguage();
  const values = t('coreValues.values');
  
  return (
    <section className="bg-[#e21b1b] py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-montserrat font-black text-white text-2xl sm:text-3xl lg:text-4xl mb-12 text-center uppercase">
          {t('coreValues.title')}
        </h2>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Image */}
          <div className="relative flex justify-center lg:justify-start">
            <div className="w-full max-w-md overflow-hidden shadow-2xl rounded-lg">
              <img
                src="/fire_safety_generated.webp"
                alt="Brandveiligheid illustratie"
                className="w-full h-auto object-cover"
                loading="lazy"
              />
            </div>
          </div>

          {/* Core Values List */}
          <div className="space-y-6">
            {values.map((value, index) => {
              const IconComponent = icons[index];
              return (
                <div
                  key={index}
                  className="flex items-start space-x-4 group"
                >
                  <div className="flex-shrink-0 w-12 h-12 bg-white rounded-lg flex items-center justify-center group-hover:bg-[#1a1a1a] transition-colors duration-300">
                    <IconComponent className="w-6 h-6 text-[#e21b1b] group-hover:text-white transition-colors duration-300" />
                  </div>
                  <div>
                    <h3 className="font-montserrat font-bold text-white text-lg mb-1">
                      {value.title}
                    </h3>
                    <p className="font-roboto text-white/90 text-base">
                      {value.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoreValues;
